"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Tooltip = void 0;
var dom_interact_1 = require("../helpers/dom-interact");
var Tooltip = /** @class */ (function () {
    function Tooltip(holder) {
        this.holder = holder;
        this.tooltip = (0, dom_interact_1.getHTMLElement)(holder, '.js-tooltip');
        this.tooltipSwitcher = (0, dom_interact_1.getHTMLElement)(holder, '.js-tooltip-switcher');
        this.isOpen = false;
        this.init();
    }
    Tooltip.prototype.init = function () {
        var _this = this;
        var closeButton = (0, dom_interact_1.getHTMLElement)(this.tooltip, '.js-close-button');
        this.tooltipSwitcher.addEventListener('click', function () { return _this.toggleTooltip(); });
        closeButton.addEventListener('click', function () { return _this.closeTooltip(); });
        this.handleOutsideClick = this.handleOutsideClick.bind(this);
    };
    Tooltip.prototype.closeTooltip = function () {
        this.isOpen = false;
        this.tooltip.classList.add('is-hidden');
        document.removeEventListener('click', this.handleOutsideClick);
    };
    Tooltip.prototype.openTooltip = function () {
        this.isOpen = true;
        this.tooltip.classList.remove('is-hidden');
        document.addEventListener('click', this.handleOutsideClick);
    };
    Tooltip.prototype.handleOutsideClick = function (event) {
        if (!this.isOpen || event.target === this.tooltipSwitcher || event.target === this.tooltip) {
            return;
        }
        var children = this.tooltip.childNodes;
        var inside = false;
        for (var i = 0; i < children.length; i++) {
            if (children[i] === event.target) {
                inside = true;
            }
        }
        if (!inside) {
            this.closeTooltip();
        }
    };
    Tooltip.prototype.toggleTooltip = function () {
        if (this.isOpen) {
            this.closeTooltip();
        }
        else {
            this.openTooltip();
        }
    };
    return Tooltip;
}());
exports.Tooltip = Tooltip;
